import Emitter from '../core/Emitter';

var _style = 'light';

class DashboardWidget extends Emitter {
	constructor(options) {
		super();
		if(!options) {
			options = {
				style: 'light'
			};
		}

		this.style = options.style;
		this.status = 'loading';

		this.addEventListener('pause', () => {
			this.status = 'paused';
		});

		this.addEventListener('resume', () => {
			this.status = 'running';
		});
	}

	render(targetEl, data, ctx, deferred) {
		this.dispatchEvent(new Event('resize'));
		this.status = 'running';
	}

	update(data, ctx) {

	}

	get style() {
		return _style;
	}

	set style(value) {
		if(!(value === 'dark' || value === 'light')) {
			throw new TypeError('not allowed');
		}
		_style = value;
	}
}

DashboardWidget.MAX = 1000;

export default DashboardWidget;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/dashboard/DashboardWidget.js